import React from 'react';
import ReactDOM from 'react-dom';

import ContentUGCPermissions from  '@/components/elements/contentUGCPermissions/contentUGCPermissions';
import { Tag } from 'react-tag-autocomplete';

const ContentUGCPermissionsPortal = () =>  {


    let groupsAllowedToPost: Tag[] = []
   

    // Container ref
    const targetContainer = document.getElementById('react-ugc-segmentation-portal');
    
    //data-allowedToPost


    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }else {
       
        const groupsAllowedToPostIds = targetContainer?.getAttribute?.('data-allowedToPost')?.split(' ').join('').split(',') || [];
        const groupsAllowedToPostNames = targetContainer?.getAttribute?.('data-allowedToPostNames')?.split(',') || [];

        groupsAllowedToPostIds.forEach((id, idx) => {
            if(id) {
                groupsAllowedToPost.push({label: groupsAllowedToPostNames[idx], value: Number(id)})
            }
            
        })
    }

    return ReactDOM.createPortal(
        <ContentUGCPermissions  groupsAllowedToPost={groupsAllowedToPost}/>, targetContainer
    );
  
}

export default ContentUGCPermissionsPortal;